import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Page from 'evcharging/components/Page';
import Footer from 'evcharging/containers/layout/Footer';
import CalculatorCard from 'evcharging/containers/ev-calculator/CalculatorCard';
import Section from 'evcharging/containers/layout/Section';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';
import { EV_CALCULATOR_LINK } from 'evcharging/app/seo/pages';
import FaqSection from 'evcharging/containers/layout/FaqSection';
import StayUpdated from 'evcharging/containers/layout/StayUpdated';
import EndToEnd from 'evcharging/containers/layout/EndToEnd';
import CalculatorHeader from 'evcharging/containers/ev-calculator/CalculatorHeader';
import { I18nPage } from 'i18n/types/pages.enum';

const EvCalculatorPage: FC<StaticPageProps> = ({ page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title}
    description={page.meta_description}
  >
    <Navigation />
    <CalculatorHeader />
    <Section background={'middle'}>
      <CalculatorCard />
      <EndToEnd />
      <RequestConsultation />
    </Section>
    <FaqSection faqs={page.faqs} />
    <StayUpdated />
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  EV_CALCULATOR_LINK,
  undefined,
  [I18nPage.EvChargingCommon, I18nPage.EvChargingCalculator, I18nPage.EnergyRates]
);

export default EvCalculatorPage;
